import {DestinoNotificacao, RotuloDestinoNotificacao} from "../model/DestinoNotificacao";
import {NotificacaoEnvio} from "../dto/NotificacaoEnvio";
import {NotificacaoEnvioResultado} from "../dto/NotificacaoEnvioResultado";

export const TITULO_MAX_CARACTERES = 65;
export const TEXTO_MAX_CARACTERES = 240;

export interface NotificacaoEnvioForm {
    destino?: DestinoNotificacao;
    restauranteUuids: string[];
    titulo: string;
    texto: string;
}

export interface MensagemResultado {
    tipo: "info" | "warning";
    texto: string;
}

export const validarNotificacaoEnvio = (form: NotificacaoEnvioForm): string | undefined => {
    const titulo = form.titulo.trim();
    const texto = form.texto.trim();

    if (!titulo) return "Informe o título.";
    if (titulo.length > TITULO_MAX_CARACTERES) return `O título pode ter no máximo ${TITULO_MAX_CARACTERES} caracteres.`;
    if (!texto) return "Informe o texto.";
    if (texto.length > TEXTO_MAX_CARACTERES) return `O texto pode ter no máximo ${TEXTO_MAX_CARACTERES} caracteres.`;
    if (!form.destino || !Object.values(DestinoNotificacao).includes(form.destino)) return "Destino inválido.";

    return undefined;
}

export const montarNotificacaoEnvio = (form: NotificacaoEnvioForm): NotificacaoEnvio => {
    const envio: NotificacaoEnvio = {
        destino: form.destino as DestinoNotificacao,
        titulo: form.titulo.trim(),
        texto: form.texto.trim(),
    };

    if (form.destino === DestinoNotificacao.CLIENTE) {
        envio.restauranteUuids = form.restauranteUuids;
    }

    return envio;
}

export const descreverDestino = (form: NotificacaoEnvioForm): string => {
    const rotulo = RotuloDestinoNotificacao[form.destino as DestinoNotificacao];

    if (form.destino === DestinoNotificacao.CLIENTE && form.restauranteUuids.length > 0) {
        return `${rotulo} de ${form.restauranteUuids.length} restaurante(s)`;
    }

    return rotulo;
}

export const mensagemResultado = (resultado: NotificacaoEnvioResultado): MensagemResultado => {
    if (resultado.aparelhos > 0) {
        return {
            tipo: "info",
            texto: `Notificação enviada para ${resultado.enviados} de ${resultado.aparelhos} aparelho(s).`
        };
    }

    return {tipo: "warning", texto: "Nenhum aparelho encontrado para esse destino."};
}

export const extrairMensagemErro = (erro: Error): string => {
    try {
        const corpo = JSON.parse(erro.message);
        if (typeof corpo?.mensagem === "string") return corpo.mensagem;
    } catch (e) {
        return erro.message;
    }
    return erro.message;
}
